export { default as localStorage } from "./localStorage";
export { default as cookie } from "./cookie";
export { default as signal } from "./signal";
import ShortUniqueId from 'short-unique-id'
import cookie from "./cookie";
import i18n from '@/i18n';

// 获取url参数
export const getUrlParams = function(url) {
  url = url || window.location.href;
  const _pa = url.substring(url.indexOf("?") + 1);
  const _arrS = _pa.split("&");
  const _rs = {};
  for (let i = 0, _len = _arrS.length; i < _len; i++) {
    const pos = _arrS[i].indexOf("=");
    if (pos === -1) {
      continue;
    }
    const name = _arrS[i].substring(0, pos);
    const value = decodeURIComponent(_arrS[i].substring(pos + 1));
    _rs[name] = value;
  }
  return _rs;
};

// 判断是静态资源是外部还是内部链接
export const isExternal = function(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
};

// 判断键盘大写键 是否锁定
export const detectCapsLock = function(event) {
  const e = event || window.event;
  const { key } = e;
  return key && key.length === 1 && key >= "A" && key <= "Z";
};

// 驼峰转换下划线
export const camelToUnderline = function(str) {
  const trans = str.replace(/([A-Z])/g, "_$1").toLowerCase();
  return trans;
};

// 下划线转换驼峰
export const underlineToCamel = function(str) {
  return str.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());
};

/** 校验类 */

// 校验url填写是否合法正则
export const validURL = function(url) {
  const reg = /(http|https):\/\/([\w.]+\/?)\S*/;
  return reg.test(url);
};

// 检测手机号格式
export const checkPhoneNumber = phone => {
  const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
  return reg.test(phone);
};

// 邮箱验证正则
export const checkEmail = email => {
  const reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
  return reg.test(email);
};

// 身份证验证正则 完整的太复杂 只做了位数校验
export const checkCertificate = cer => {
  const reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
  return reg.test(cer);
};

/**
 * 动态加载资源
 * @param {*} jss
 * @param {*} i
 * @param {*} callback
 * @returns
 */
export const loadScript = (jss = [], i, callback) => {
  if (!Array.isArray(jss)) {
    return false;
  }

  if (jss.length == 0 || i > jss.length) {
    return false;
  }

  if (i == jss.length) {
    callback && callback();
    console.log("loadScript | JS files loaded");
    return;
  }

  let oHead = document.getElementsByTagName("head").item(0);
  let oScript = document.createElement("script");
  const { url = "", callBack: onReadyCB = () => {} } = jss[i] || {};
  oScript.type = "text/javascript";
  oScript.src = url;
  oScript.callBack = onReadyCB;
  oScript.charset = "UTF-8";
  oHead.appendChild(oScript);
  if (oScript.readyState) {
    // IE
    oScript.onreadystatechange = function() {
      if (oScript.readyState == "loaded" || oScript.readyState == "complete") {
        oScript.onreadystatechange = null;
        oScript.callBack();
        loadScript(jss, i + 1, callback);
      }
    };
  } else {
    // Other
    oScript.onload = function() {
      oScript.callBack();
      loadScript(jss, i + 1, callback);
    };
  }
};

/**
 * 递归转换菜单：对象转数组形式
 * @param {*} data
 * @param {*} result
 * @returns
 */
export const loopMenu = (data, result = []) => {
  let entries = Object.entries(data) || [];
  entries.sort(function([key1, menu1], [key2, menu2]) {
    return menu1.sort - menu2.sort;
  });
  entries.forEach(function(entry) {
    const [key, item] = entry || [];

    let menu = {
      menuKey: key,
      ...item
    };

    result.push(menu);

    if (item.children) {
      menu.children = [];
      loopMenu(item.children, menu.children);
      menu.count = menu.children.reduce((total, child) => {
        return total + child.count;
      }, 1);
    } else {
      menu.count = 1;
    }
    if (item.sub_menu) {
      menu.sub_menu = []
      loopMenu(item.sub_menu, menu.sub_menu)
    }
  });

  return result;
};

/**
 * 递归获取菜单的key
 * @param {Array} ac_menus
 * @param {Array} result
 * @returns
 */
export const returnMenuKeys = (ac_menus = [], result = []) => {
  let menus = [];
  if (Array.isArray(ac_menus)) {
    menus = [...ac_menus];
  } else {
    menus.push(ac_menus);
  }

  menus.map(item => {
    if (item.children) {
      result.push(item.menuKey);
      returnMenuKeys(item.children, result);
    }
  });
  return result;
};

export const getDocumentHiddenKey = () => {
  // 设置隐藏属性和改变可见属性的事件的名称
  let hidden, visibilityChange;

  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof document.mozHidden !== "undefined") {
    hidden = "mozHidden";
    visibilityChange = "mozvisibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }

  return {
    value: document[hidden],
    hidden: hidden,
    visibilityChange: visibilityChange
  };

  // 事件监听代码示例
  if (
    typeof document.addEventListener !== "undefined" &&
    typeof document[hidden] !== "undefined"
  ) {
    // 处理页面可见属性的改变
    document.addEventListener(
      visibilityChange,
      () => {
        console.log(document.hidden, "document.hidden");
        this._visibilityState = document.hidden;
      },
      false
    );
  }
};

//==========================百度统计 start=======================================
/**
 * 事件统计
 * @param {Object} params
 * @param {String} params.product 产品模块名称
 * @param {String} params.action_name 具体的菜单名称或操作名称
 */
export const zt_track_event = params => {
  let _hmt = window._hmt;
  let _paq = window._paq;
  const categroy = cookie.getCookie("vcc_code") || "vcc_code";
  if (_hmt) {
    let action = params.product || "ekt";
    let opt_label = params.action_name || "";
    _hmt.push(["_trackEvent", categroy, action, opt_label]);
  }

  if (_paq) {
    let action = params.product || "ekt";
    let opt_label = params.action_name || "";
    _paq.push(["trackEvent", action, opt_label, categroy]);
  }
};

export const hmt_statistic = (url, subtitle) => {
  // 统计菜单点击次数
  try {
    let url_arr = url.split(".");
    let url_domain = url_arr[0];
    if (url_domain === "index") {
      url_domain = "ekt";
    } else {
      url_domain = url_domain.replace("https://", "");
      url_domain = url_domain.replace("http://", "");
      url_domain = url_domain.replace("//", "");
    }
    // 处理菜单名称，将动态信息去除，例如186********来电等处理为呼入进线等
    let action_name = "";
    let isTel = /0\d{2,3}[-]?\d{7,8}|0\d{2,3}\s?\d{7,8}|1[3-9]\d{9}/.test(
      subtitle
    );
    if (
      subtitle.substring(0, 4) === "工单查看" ||
      subtitle.substring(0, 4) === "工单编辑" ||
      subtitle.substring(0, 4) === "业务受理"
    ) {
      action_name = subtitle.substring(0, 4);
    } else if (subtitle.substring(0, 5) === "受理单详情") {
      action_name = subtitle.substring(0, 5);
    } else if (
      subtitle.substring(0, 2) === "呼入" ||
      subtitle.substr(0, 2) === "呼出"
    ) {
      action_name = subtitle.substring(0, 2);
    } else if (subtitle.substr(-2) === "来电" && subtitle !== "未接来电") {
      action_name = subtitle.substr(-2);
    } else if (
      subtitle.substr(-2) === "==" ||
      subtitle.indexOf("****") != -1 ||
      isTel
    ) {
      action_name = "通话弹屏";
    } else {
      action_name = subtitle;
    }
    zt_track_event({
      product: url_domain,
      action_name: action_name
    });
  } catch (e) {
    console.log(e.message);
  }
};

//==========================百度统计 end=======================================

/**
 * 根据路径获取对象的属性值
 * @param {Object} obj
 * @param {Array<string>} pathArr
 * @param {any} defaultVal：默认值
 * @returns
 */
export const getValByPath = (obj = {}, pathArr = [], defaultVal = false) => {
  let result = obj;

  if (!Array.isArray(pathArr)) {
    return defaultVal;
  }
  let len = pathArr.length;
  if (len == 0) {
    return defaultVal;
  }

  for (let i = 0; i < len; i++) {
    if (typeof result === "undefined") {
      result = defaultVal;
      break;
    }

    const path = pathArr[i];
    result = result[path];
  }

  return result;
};

export const browserCheck = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  let isChrome = false;
  let isFirefox = false;
  let isEdg = false;

  let isSafari = false;
  let isIE = false;
  let isOp = false;
  let isQQ = false;

  let ActualVersion = "";
  let ActualName = "";

  if (userAgent.indexOf("opr") > -1) {
    isOp = true;
    ActualName = "Opera";
    ActualVersion = userAgent.split(/opr\//)[1];
  } else if (userAgent.indexOf("qqbrowser") > -1) {
    isQQ = true;
    ActualName = "QQ";
    ActualVersion = userAgent.split(/qqbrowser\//)[1];
  } else if (userAgent.indexOf("trident") > -1) {
    isIE = true;
    ActualName = "IE";
  } else if (userAgent.indexOf("edg") > -1) {
    isEdg = true;
    ActualName = "Edge";
    ActualVersion = userAgent.split(/edg\//)[1];
  } else if (userAgent.indexOf("firefox") > -1) {
    isFirefox = true;
    ActualName = "Firefox";
    ActualVersion = userAgent.split(/firefox\//)[1];
  } else if (userAgent.indexOf("safari") > -1) {
    if (userAgent.indexOf("chrome") > -1) {
      isChrome = true;
      ActualName = "Chrome";
      ActualVersion = userAgent
        .split(/chrome\//)[1]
        .split("safari")[0]
        .trim();
    } else {
      isSafari = true;
      ActualName = "Safari";
      ActualVersion = userAgent.split(/safari\//)[1];
    }
  } else {
    ActualName = "Unknown Navigator";
    ActualVersion = "Unknown Version";
  }

  return {
    isChrome,
    isFirefox,
    isEdg,

    isSafari,
    isIE,
    isOp,
    isQQ,

    ActualName,
    ActualVersion
  };
};

// 获取唯一标识, 默认10位
export const getShortId = (length = 10, prefix = '') => {
  const shortId = new ShortUniqueId({
    length
  })
  return prefix + shortId.rnd()
}



// WEBPACK FOOTER //
// ./src/utils/index.js